export enum Provider {
  DATAZOOM = 'Datazoom',
  CONVIVA = 'Conviva',
  NPAW = 'NPAW',
  NEWRELIC = 'New Relic',
  GODAVARI = 'Godavari',
  UNKNOWN = 'Unknown',
}
